export default {
    CREATE_COMMENT: () => '/emailComment',
    GET_COMMENT: () => '/emailComment',
    UPDATE_COMMENT: (id) => `/emailcomment/${id}`,
    GET_COMMENT_BY_ID: (id) => `/emailcomment/${id}`,
    DELETE_COMMENT: (id) => `/emailcomment/${id}`,
    SEND_COMMENT: () => `/email/sentComment`,
    GET_ALL_EMAIL_ASSIGN_USER_BY_ID: (id) => `/emailComment/getBoardByTaskId/${id}`,
    CREATE_PROPERTY: () => '/addProperty',
};